var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / 24px / warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon / 24px / warning_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3684 5.87938L18 3L19.6316 5.87938L33.381 30.1429L35 33H31.7367H4.26329H1L2.61905 30.1429L16.3684 5.87938ZM5.88234 30.1429L18 8.75876L30.1177 30.1429H5.88234ZM19.4167 21.5714V15.8571H16.5833V21.5714H19.4167ZM19.4167 27.2857V24.4286H16.5833V27.2857H19.4167Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.f79a3714eb3c887ee5414490c6aee911.svg";
export { ForwardRef as ReactComponent };